import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"12"}},[_c('kiosk-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }